"use client";

import { useEffect, useRef } from "react";
import type { SpaceBackgroundVariant } from "@/game/backgrounds/SpaceMenuBackgroundScene";
import { waitForElementSize } from "@/lib/waitForElementSize";

interface SpaceMenuBackgroundProps {
  variant?: SpaceBackgroundVariant;
}

export function SpaceMenuBackground({ variant = "home" }: SpaceMenuBackgroundProps) {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    let scene: import("@/game/backgrounds/SpaceMenuBackgroundScene").SpaceMenuBackgroundScene | null =
      null;
    let cancelled = false;

    (async () => {
      try {
        await waitForElementSize(host);
        if (cancelled) return;
        const { SpaceMenuBackgroundScene } = await import(
          "@/game/backgrounds/SpaceMenuBackgroundScene"
        );
        scene = new SpaceMenuBackgroundScene(variant);
        await scene.init(host);
      } catch (err) {
        console.error("[SpaceMenuBackground] init failed:", err);
      }
    })();

    return () => {
      cancelled = true;
      scene?.destroy();
      host.replaceChildren();
    };
  }, [variant]);

  return (
    <div
      ref={hostRef}
      className="pointer-events-none absolute inset-0 z-0 overflow-hidden"
      aria-hidden
    />
  );
}
